// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__LWLOL","vLegacy":"SelectSecondary_vLegacy__2vbij","error":"SelectSecondary_error__1fbN4","disabled":"SelectSecondary_disabled__2-NDU"};